import React from 'react';
import { Dropdown, Icon } from 'semantic-ui-react';

import { auth } from '../firebase';

const Logout = () => (
  <Dropdown.Item onClick={auth.signOut}>
    <Icon name="lock" /> SignOut
  </Dropdown.Item>
);

export default Logout;



// WEBPACK FOOTER //
// ./src/components/Logout.jsx